import SwitcherPages from './SwitcherPages'

export default SwitcherPages
